import React, { Component } from 'react';
import { withFirebase } from '../firebase';
import { AuthUserContext, withAuthorization } from '../session';

const Admin = () => (
  <AuthUserContext.Consumer>
    {ctx => (
      <div>
        <img
          className="Profile-logo"
          src={process.env.PUBLIC_URL + '/img/logo.png'}
          alt="logo"
        />
        <h1 className="Profile-title">Admin</h1>

        <AdminPage authUser={ctx.authUser} />
      </div>
    )}
  </AuthUserContext.Consumer>
);


class AdminPageBase extends Component {
  constructor(props) {
    super(props);
    this.state = {}

    this.exportAllUsers = this.exportAllUsers.bind(this)
  }

  componentDidMount() {
  }

  componentWillUnmount() {
    this.props.firebase.users().off();
  }

  codeCount() {
    window.location = "https://firebase-sonad.appspot.com"
  }

  codeGenerate() {
    window.location = "https://firebase-sonad.appspot.com/api/create_codes?auth=5LgdMbRQacz5XMrhFCxR&n=100"
  }

  exportAllUsers() {
    let {firebase} = this.props
    let export_fn = firebase.functions.httpsCallable('exportAllAuthUsers')
    export_fn().then(function(result) {
      // Read result of the Cloud Function.
      console.log(result.data)
      if (result.data.url != null) {
        window.location = result.data.url
      } else {
        alert(result.data.message)
      }
    });
  };

  render() {
    return (
      <div>
        <div>
          <h3>Reports & Admin Actions</h3>

          <h4>1) All users export (from Firebase/Authentication)</h4>
          <button type="button" className="BigButton" onClick={this.exportAllUsers}>Generate</button>
          &nbsp;<small>(saves CSV to Firebase storage)</small>

          <h4>2) Get count of codes</h4>
          <button type="button" className="BigButton" onClick={this.codeCount}>Count</button>

          <h4>3) Generate 100 new codes</h4>
          <button type="button" className="BigButton" onClick={this.codeGenerate}>Generate</button>

        </div>
      </div>
    )
  }
}

const AdminPage = withFirebase(AdminPageBase);

const condition = authUser => !!authUser;
export default withAuthorization(condition)(Admin);
